import { DiamondPlus, Funnel, OctagonMinus } from 'lucide-react';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { Message } from 'primereact/message';

import FilterSection from './FilterSection';

const ReportPanel = ({
  selectedTable,
  selectedChartTable,
  action,
  setShowTableFilter,
  copyFilterChart,
  widgetFormik,
  dimensionList,
  isWarrantyEnabled,
  showTableFilter,
  chartFilterCopied,
  isCopyUse,
}) => {
  const headerTemplate = () => {
    return (
      <div className="flex align-items-center gap-2 text-sm font-medium text-gray-700">
        <Funnel className="text-primary text-sm w-1rem h-1rem" />
        <span className="text-sm font-bold text-gray-500">Report Filters</span>
        {selectedTable == selectedChartTable &&
          widgetFormik.values.widget_type != 'table-report' && (
            <Button
              size="small"
              onClick={() => copyFilterChart()}
              label="Copy from Chart"
              outlined
            ></Button>
          )}
        {chartFilterCopied ? (
          <Message
            severity="success"
            text="Filters copied from chart"
            pt={{ root: { className: 'border-1' } }}
          />
        ) : null}
      </div>
    );
  };

  return (
    <Panel header={headerTemplate} className="w-full">
      <div className="grid grid-nogutter gap-2">
        {action !== 'view' && (
          <>
            {showTableFilter ? (
              <Button
                disabled={
                  widgetFormik.values.table_filter_conditions?.filters?.[0]
                    ?.fields?.[0]?.tableField && showTableFilter
                }
                icon={<OctagonMinus className="text-sm w-1rem h-1rem" />}
                pt={{ label: { className: 'pl-1 text-xs' } }}
                label="Remove Filter Condition"
                className={`border-round-md py-2`}
                onClick={() => {
                  if (
                    !(
                      widgetFormik.values.table_filter_conditions?.filters?.[0]
                        ?.fields?.[0]?.tableField && showTableFilter
                    )
                  ) {
                    setShowTableFilter(false);
                  }
                }}
              />
            ) : (
              <Button
                icon={<DiamondPlus className="text-sm w-1rem h-1rem" />}
                label="Add New Filter Condition"
                pt={{ label: { className: 'pl-1 text-xs' } }}
                className={`border-round-md py-2`}
                onClick={() => {
                  setShowTableFilter(true);
                }}
              />
            )}
          </>
        )}
        {showTableFilter && (
          <FilterSection
            widgetFormik={widgetFormik}
            filterConditions={widgetFormik.values.table_filter_conditions}
            action={action}
            dimensionList={dimensionList?.filter(item => {
              let flag = true;
              if (item?.meta?.tenantPermission) {
                flag = isWarrantyEnabled();
              }
              return (
                item?.firstLetter === selectedTable &&
                !item?.meta?.hideInFilter &&
                flag
              );
            })}
            filterFor="table_filter_conditions"
            isCopyUse={isCopyUse}
          />
        )}
      </div>
    </Panel>
  );
};

export default ReportPanel;
